import * as React from 'react';
import Paper from '@mui/material/Paper';
import {
    DataGrid,
    GridFooterContainer,
    GridSelectedRowCount,
    selectedGridRowsCountSelector,
    useGridApiContext,
    useGridSelector,
} from '@mui/x-data-grid';
import './Table.scss';

// Pie con un resumen centrado bajo un separador (ej. el total) en lugar de la paginacion.
// Pensado para tablas que muestran todas sus filas en una sola pagina.
const SummaryFooter = ({summary}) => {
    const apiRef = useGridApiContext();
    const selectedRowCount = useGridSelector(apiRef, selectedGridRowsCountSelector);

    return (
        <GridFooterContainer className={'v2-table-summary-footer'}>
            <div>
                {selectedRowCount > 0 && <GridSelectedRowCount selectedRowCount={selectedRowCount}/>}
            </div>
            <div className={'v2-table-footer-summary'}>{summary}</div>
        </GridFooterContainer>
    );
};

const Table = ({
                   includeCheckbox,
                   attributes,
                   rows,
                   onPageSizeChange,
                   onPageChange,
                   rowCount,
                   pageSize,
                   pageSizeOptions,
                   noSelectableRowsIds,
                   onRowClick,
                   currentPage,
                   selectedRows,
                   onSelectRow,
                    noRowsMessage,
                   autoHeight,
                   footerSummary,

               }) => {
    const columns = attributes.map((attribute) => ({
        field: attribute.att,
        headerName: attribute.title,
        flex: attribute.flex || 1,
        sortable: attribute.sortable !== undefined ? attribute.sortable : true,
        align: attribute.align || 'left',
        renderCell: attribute.renderCell,
        valueGetter: attribute.valueGetter,
    }));


    const getRowClassName = (params) => {
        let className = '';
        className += params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row ' : 'odd-row ';
        className += onRowClick ? 'cursor-pointer' : '';
        return className;
    };


    return (
        <Paper sx={{height: '100%', width: '100%'}}>
            <DataGrid
                autoHeight={autoHeight}
                rows={rows}
                rowCount={rowCount}
                isRowSelectable={(params) => {
                    return noSelectableRowsIds ? !noSelectableRowsIds.includes(params.row.id) : true;
                }}
                initialState={{
                    sorting: {
                        sortModel: [{field: 'id', sort: 'asc'}], // Sets initial sort order
                    },
                }}
                pageSize={pageSize || 10}
                onPageSizeChange={(value) => onPageSizeChange(value)}
                getRowClassName={getRowClassName}
                rowsPerPageOptions={pageSizeOptions ? pageSizeOptions: []}
                checkboxSelection={includeCheckbox}
                disableColumnMenu
                disableSelectionOnClick
                onRowClick={(row) => onRowClick && onRowClick(row.row)}
                onSelectionModelChange={(rows) => onSelectRow(rows)}
                selectionModel={selectedRows ? selectedRows.map((row) => row.medicalServiceId) : []}
                columns={columns}
                pagination
                filterMode="server"
                paginationMode="server"
                page={currentPage - 1 >= 0 ? currentPage - 1 : 0}
                onPageChange={(params) => onPageChange(params + 1)}
                sx={{border: 0, overflow: 'hidden'}}
                components={footerSummary ? {Footer: SummaryFooter} : undefined}
                componentsProps={{
                    footer: {summary: footerSummary},
                    pagination: {
                        labelRowsPerPage: 'Filas por página',
                        labelDisplayedRows: ({from, to}) => `${from}-${to} de ${rowCount}`,
                    },
                }}
                localeText={{
                    footerRowSelected: (count) =>
                        count === 1 ? `${count} fila seleccionada` : `${count} filas seleccionadas`,
                    noRowsLabel: noRowsMessage || 'No hay filas',
                    noResultsOverlayLabel: noRowsMessage || 'No hay filas',
                }}
                keepNonExistentRowsSelected

            />
        </Paper>
    );
};

export default Table;
